export const config = {
  api_local: process.env.REACT_APP_API_URL, 
  site: process.env.REACT_APP_SITE, 
  url_789bet: "789bet",
  BE_API_URL: process.env.REACT_APP_API_URL,
  LIST_REQUEST_BANK: [
    "Xóa số tài khoản",
    "Thêm số tài khoản",
    "Đổi số tài khoản",
  ],
  basename: '/',
};